import { useCallback, useEffect, useState } from 'react';
import { listMyTickets, type SupportTicketSummary } from '../../../services/helpTicketService';

const storageKey = (userId: string) => `selfservice_help_completed_seen_${userId}`;

export function useHelpCompletedNotification(userId: string | undefined) {
  const [hasUnreadCompleted, setHasUnreadCompleted] = useState(false);

  const refresh = useCallback(async () => {
    if (!userId) {
      setHasUnreadCompleted(false);
      return;
    }
    try {
      const tickets = await listMyTickets();
      const seenIso = localStorage.getItem(storageKey(userId));
      const seenMs = seenIso ? new Date(seenIso).getTime() : 0;
      const latestCompleted = tickets
        .filter((t): t is SupportTicketSummary & { completedAt: string } => Boolean(t.completedAt))
        .map((t) => new Date(t.completedAt).getTime())
        .reduce((max, ms) => Math.max(max, ms), 0);
      setHasUnreadCompleted(latestCompleted > seenMs);
    } catch {
      setHasUnreadCompleted(false);
    }
  }, [userId]);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  const markCompletedSeen = useCallback(() => {
    if (!userId) return;
    localStorage.setItem(storageKey(userId), new Date().toISOString());
    setHasUnreadCompleted(false);
  }, [userId]);

  return { hasUnreadCompleted, refresh, markCompletedSeen };
}
